import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { HelpComponent } from './pages/help/help.component';
import { HomeComponent } from './pages/home/home.component';
import { GettingStartedComponent } from './pages/getting-started/getting-started.component';
import { IsLoggedInGuard } from './guards/is-logged-in.guard';
import { AboutComponent } from './pages/about/about.component';
import { TermsComponent } from './pages/terms/terms.component';
import { PrivacyComponent } from './pages/privacy/privacy.component';
import { SupportComponent } from './pages/support/support.component';
import { PremiumUnifiedComponent } from './pages/premium-unified/premium-unified.component';
import { MigrationComponent } from './pages/migration/migration.component';
import { GuildSelectionComponent } from './pages/guild-selection/guild-selection.component';
import { GuildDashboardComponent } from './pages/guild-dashboard/guild-dashboard.component';
import { ChannelCardComponent } from './pages/guild-dashboard/channel-card/channel-card.component';
import { ServerCardComponent } from './pages/guild-dashboard/server-card/server-card.component';
import { UserCardComponent } from './pages/guild-dashboard/user-card/user-card.component';
import { OverviewCardComponent } from './pages/guild-dashboard/overview-card/overview-card.component';
import { SignupTemplateCardComponent } from './pages/guild-dashboard/signupTemplate-card/signupTemplate-card.component';
import { adminPermissionGuard } from './guards/admin-permission.guard';
import { signupTemplateLimitsGuard } from './guards/signup-template-limits.guard';
import { EventCardComponent } from './pages/guild-dashboard/event-card/event-card.component';
import { organizerPermissionGuard } from './guards/organizer-permission.guard';
import { SignupGroupCardComponent } from './pages/guild-dashboard/signupGroup-card/signupGroup-card.component';
import { RepeatingEventCardComponent } from './pages/guild-dashboard/repeating-event-card/repeating-event-card.component';
import { repeatingEventLimitsGuard } from './guards/repeating-event-limits.guard';
import { signupGroupLimitsGuard } from './guards/signup-group-limits.guard';
import { channelLimitsGuard } from './guards/channel-limits.guard';
import { TemplatesCatalogueComponent } from './pages/templates-catalogue/templates-catalogue.component';
import { TemplateDetailComponent } from './pages/template-detail/template-detail.component';
import { TemplatesReviewComponent } from './pages/templates-review/templates-review.component';
import { MyTemplatesComponent } from './pages/my-templates/my-templates.component';
import { botOwnerGuard } from './guards/bot-owner.guard';

const routes: Routes = [
  { path: '', component: HomeComponent },
  { path: 'getting-started', component: GettingStartedComponent },
  { path: 'help', component: HelpComponent },
  { path: 'about', component: AboutComponent },
  { path: 'terms', component: TermsComponent },
  { path: 'privacy', component: PrivacyComponent },
  { path: 'support', component: SupportComponent },
  { path: 'premium', component: PremiumUnifiedComponent },
  { path: 'migration', component: MigrationComponent },
  { path: 'templates', component: TemplatesCatalogueComponent },
  {
    path: 'templates/review',
    component: TemplatesReviewComponent,
    canActivate: [IsLoggedInGuard, botOwnerGuard],
  },
  {
    path: 'templates/mine',
    component: MyTemplatesComponent,
    canActivate: [IsLoggedInGuard],
  },
  { path: 'templates/:id', component: TemplateDetailComponent },
  { path: 'guilds', canActivate: [IsLoggedInGuard], component: GuildSelectionComponent },
  {
    path: 'guilds/:id',
    canActivate: [IsLoggedInGuard],
    component: GuildDashboardComponent,
    children: [
      { path: '', redirectTo: 'overview', pathMatch: 'full' },
      { path: 'overview', component: OverviewCardComponent },
      { path: 'server', component: ServerCardComponent },
      { path: 'channel/new', component: ChannelCardComponent, canActivate: [adminPermissionGuard, channelLimitsGuard]},
      { path: 'channel/:channelId', component: ChannelCardComponent },
      { path: 'event/create', component: EventCardComponent, canActivate: [organizerPermissionGuard]},
      { path: 'signup-template/new', component: SignupTemplateCardComponent, canActivate: [adminPermissionGuard, signupTemplateLimitsGuard]},
      { path: 'signup-template/:signupTemplateId', component: SignupTemplateCardComponent, canActivate: [adminPermissionGuard]},
      { path: 'signup-group/new', component: SignupGroupCardComponent, canActivate: [adminPermissionGuard, signupGroupLimitsGuard]},
      { path: 'signup-group/:signupGroupId', component: SignupGroupCardComponent, canActivate: [adminPermissionGuard]},
      { path: 'repeating-event/new', component: RepeatingEventCardComponent, canActivate: [organizerPermissionGuard, repeatingEventLimitsGuard]},
      { path: 'repeating-event/:repeatingEventId', component: RepeatingEventCardComponent, canActivate: [organizerPermissionGuard]},
      { path: 'premium', component: PremiumUnifiedComponent },
      { path: 'user', component: UserCardComponent },
    ]
  },
  { path: '**', redirectTo: '/' },
];

@NgModule({
  imports: [
    RouterModule.forRoot(routes, {
      // Catalogue list content loads async; restoration is handled there after data arrives.
      scrollPositionRestoration: 'disabled',
    }),
  ],
  exports: [
    RouterModule,
  ]
})
export class AppRoutingModule { }
